module.exports = __webpack_public_path__ + "static/Background-3eeff09d45e6a6daa4a30dd26637c495.png";